/** Matches `orders.exceptions.PRODUCTION_QUESTIONS_BLOCKING_CODE` on the server. */
export const PRODUCTION_QUESTIONS_BLOCKING_CODE =
	'production_questions_unresolved';

const DEFAULT_MESSAGE =
	'Cannot complete programming while production questions are unresolved.';

export const PRODUCTION_QUESTION_BLOCK_HINT =
	'Programming can be marked complete once these questions are resolved.';

/**
 * The message from the 409 the API returns when programming completion is held
 * by unresolved production questions, or null for any other error.
 */
export function getProductionQuestionBlockMessage(error: unknown): string | null {
	if (!error || typeof error !== 'object' || !('data' in error)) {
		return null;
	}
	const data = (error as { data?: unknown }).data;
	if (!data || typeof data !== 'object') {
		return null;
	}
	const body = data as Record<string, unknown>;
	if (body.code !== PRODUCTION_QUESTIONS_BLOCKING_CODE) {
		return null;
	}
	return typeof body.detail === 'string' && body.detail
		? body.detail
		: DEFAULT_MESSAGE;
}
